import axios from "axios";
import { handleApiError } from "../utils/apiUtils";
import { showSpinner, hideSpinner } from "../utils/commonUtils";

let API_URL = "";
if (process.env.REACT_APP_API_URL === "") {
  const currentProtocol = window.location.protocol;
  const currentDomain = window.location.hostname;
  const currentPort = window.location.port;
  const url = `${currentProtocol}//${currentDomain}:${currentPort}`;
  API_URL = url;
} else {
  API_URL = process.env.REACT_APP_API_URL;
}

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// リクエストのインターセプター
api.interceptors.request.use(
  (config) => {
    showSpinner();
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    hideSpinner();
    return Promise.reject(error);
  }
);

// レスポンスのインターセプター
api.interceptors.response.use(
  (response) => {
    hideSpinner();
    return response;
  },
  (error) => {
    hideSpinner();
    if (error.response && error.response.status === 401) {
      // 未認証の処理
    }
    return Promise.reject(handleApiError(error));
  }
);

export default api;
